
import React from "react";
import { ECapReportStepProps } from ".";
import AppSubmitedForm from "../../../atoms/submited-form";



const Submited = (props: ECapReportStepProps) => {

    return (
        <AppSubmitedForm
            title="Submitted successfully!"
            description="Please wait for the decision..." />
    )
}

export default Submited;